import { FunctionComponent, ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';
import EmptyAdminPanelPage from '@/shared/components/EmptyAdminPanelPage';

const TITLE = 'No sites available';
const REASON = 'Please, contact your supervisor.';

const LocationsEmpty: FunctionComponent = (): ReactElement => (
	<EmptyAdminPanelPage title="">
		<Stack justifyContent="center" alignItems="center" textAlign="center">
			<Typography component="h1" variant="h2">
				{TITLE}
			</Typography>
			<Typography component="h2" variant="h6">
				{REASON}
			</Typography>
		</Stack>
	</EmptyAdminPanelPage>
);

export default LocationsEmpty;
